import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { usePermissions } from '../../hooks/usePermissions'
import type { PermissionAction } from '../../types/@types/user'

interface Props {
  children: JSX.Element
  /** If set, the user must have this permission to access the route */
  module?: string
  action?: PermissionAction
}

export default function ProtectedRoute({ children, module, action = 'view' }: Props) {
  const { token } = useAuth()
  const { can } = usePermissions()

  if (!token) {
    return <Navigate to="/login" replace />
  }

  if (module && !can(module, action)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
